import type { GraphResponse } from '../hooks/useGraph'

export interface StatusDelta {
  elementKey: string
  health: string
}

/**
 * Applies a live status delta to a cached graph by element_key — pure, so the
 * SSE handler can reconcile via queryClient.setQueriesData without a refetch.
 * Returns the same reference when nothing matched (no needless re-render).
 */
export function applyStatusDelta(graph: GraphResponse, delta: StatusDelta): GraphResponse {
  let changed = false
  const nodes = graph.nodes.map((n) => {
    if (n.key === delta.elementKey && n.health !== delta.health) {
      changed = true
      return { ...n, health: delta.health as typeof n.health }
    }
    return n
  })
  return changed ? { ...graph, nodes } : graph
}
